// extracted by mini-css-extract-plugin
export var bar = "rooms-module--bar--ItFYx";
export var roomPrices = "rooms-module--room-prices--XMH4N";
export var roomsContent = "rooms-module--rooms-content--1KcKx";
export var roomsHeader = "rooms-module--rooms-header--ioUJf";
export var videoTour = "rooms-module--videoTour--x4Ku-";